/**
 * @generated SignedSource<<274397d8be07fd8d0a557f20ddad23e8>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserNameLabel_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employeeId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
};
node.hash = "ecda88301d78da4e33b6696118d8176a";
export default node;
